import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../PensionWorkflowConstants';
import { inputCheckboxClicked } from '../../../Profile/Accounts_react/AccountsUtils';
import YesOrNoCheckbox from '../../YesOrNoCheckbox/YesOrNoCheckboxView';
import { validateDoYouHavePension } from '../PensionWorkflowValidators';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

class DoYouHavePensionView extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      clientId, workflowId, preprocessData, pensions, isPopulated, store2,
    } = this.props;

    if (!previousIsPopulated && isPopulated) {
      preprocessData(clientId, pensions, store2(workflowId));
    }
  }

  render() {
    const {
      branch,
      workflowId,
      clientId,
      hasPension,
      hasFamily,
      store2,
      alreadyHasPensionData,
      shouldAlwaysSkip,
    } = this.props;
    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={shouldAlwaysSkip || alreadyHasPensionData}
      >
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.HasPension`} />

        <h2>{hasFamily ? 'Does your family' : 'Do you'} have any pensions?</h2>
        <YesOrNoCheckbox
          checked={hasPension}
          onClick={inputCheckboxClicked(clientId, store2(workflowId), `${BACKEND_KEY}.HasPension`)}
        />
        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          validator={validateDoYouHavePension(hasPension)}
          validationId={`${BACKEND_KEY}.HasPension`}
          workflowId={workflowId}
          backendKey={BACKEND_KEY}
          doNotSave
          validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'pension_completed')}
        />
      </AdvWorkflowStep>
    );
  }
}

DoYouHavePensionView.defaultProps = {
  hasFamily: false,
  hasPension: null,
  alreadyHasPensionData: false,
};

DoYouHavePensionView.propTypes = {
  shouldAlwaysSkip: PropTypes.bool.isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store2: PropTypes.func.isRequired,
  preprocessData: PropTypes.func.isRequired,
  isPopulated: PropTypes.bool.isRequired,
  hasFamily: PropTypes.bool,
  hasPension: PropTypes.bool,
  alreadyHasPensionData: PropTypes.bool,
  pensions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default DoYouHavePensionView;
